import { numberFormat } from './NumberFormat';

export function formatNumWithDecimal(num) {
  if (!num || isNaN(num)) return num;
  const numSplit = String(num).split('.');

  if (numSplit.length > 1) {
    const numWithoutDecimal = numberFormat(parseInt(numSplit[0]));
    return `${numWithoutDecimal}.${numSplit[1].slice(0, 2)}`;
  }
  return numberFormat(num);
}
